const DURATION = 4000; // 4 s × 1000 ms

class TimingService {
    public static $inject: string[] = [
        "$interval"
    ];

    private interval: ng.IPromise<any>;
    private duration: number = DURATION;

    constructor(
        private $interval: ng.IIntervalService
    ) {}

    public setInterval(cb, duration: number = this.duration) {
        this.stopInterval();
        this.interval = this.$interval(cb, duration);
    }

    private stopInterval() {
        if (this.interval) {
            this.$interval.cancel(this.interval);
            this.interval = null;
        }
    }
}

angular
    .module("thor.core.timing.service", [])
    .service("timingService", TimingService);
